export enum Plan {
  Free = "Free",
  Pro = "Pro",
}
